import { Box, HStack, Tooltip } from '@chakra-ui/react';
import { LockIcon } from '../../shared/icons/LockIcon';

export const LockedToolTip = ({ text }: { text: React.ReactNode }) => {
  return (
    <HStack>
      <Tooltip label={text} placement="top">
        <Box>
          <LockIcon />
        </Box>
      </Tooltip>
    </HStack>
  );
};
